module.exports = __webpack_public_path__ + "img/backhand_index_pointing_right.3bd8e970.gif";